export default "__VITE_ASSET__OXolBzoP__"